import LoginButton from "./LoginButton";
import Link from "next/link";

export default function MainLayout(props: any) {
  return (
    <div>
      <div 
        style={{
          display: "flex", justifyContent: "space-between", backgroundColor: "lightgreen",
          padding: "2px"
        }}>
        <div 
          style={{cursor: "pointer"}}
          onClick={(e: any) => {
            // globalThis.history.pushState({}, "", "/");
            props.setState({
              datasetId: null,
              dimList: [],
              filename: null,
              agg: null,
              filter: null,
              colorValues: [],
            });
          }}>
          <b>IsChart</b>
        </div>
        <div style={{display: "flex"}}>
          <div>{props.user?.email}</div>
          <LoginButton 
            onEvent={props.onEvent}
            loggedin={props.loggedin}
          />
        </div>
      </div>
      {props.children}
    </div>
  )
}
